import React from 'react';
import ReactDOM from 'react-dom';
import { setGlobal } from 'reactn';

import { ProvideAuth } from "stores/auth.js";
import { ProvideApi } from "stores/api.js";
import './i18n';
import App from './App';

import * as serviceWorker from './serviceWorker';

setGlobal({
    isDirty: false,
    modalProps: {
        showModal: false,
        messages: [],
        showCancel: false,
        size: ''
    },
    masterData: null,
    showLoader: false,
    searchParams: {
      businessUnitId: null,
      rentalCategoryId: null
    },
    offerDates: {
      startDate: null,
      endDate: null
    },
    orderRentDates: {
      startDate: null,
      endDate: null
    },
    defaultParams: {},
    searchPageVars: {
        showLocation: true,
        showCategory: true,
        currentLoc: 'All',
        currentSubcat: 'All',
        showMaps: true,
        locations: [],
        categories: [],
        objFeatureEnums: [],
        objFeatureRanges: [],
        objFacets: {},
        loaded: false
    },
    openFilters: true,
    optionsSelected: {},
    openSlider: '',
    rangeFilters: {},
    markerLoc: null,
    markerLatLng: null,
    markerVars: {
      isClicked: false,
      locationId: null
    },
    searchNow: false,
    currentTxnId: '',
    currentObjId: '',
    bookingNote: {},
    bookingNote2: {},
    objectDetails: null,
    cartCount: 0,
    orderData: null,
    orderId: '',
    isDBA: false,
    showGuestLogin: false,
    isAutoLoggedOut: false,
    isSameTimePeriod: true,
    isAgbAccepted: false
});

ReactDOM.render(
  <React.StrictMode>
      <ProvideApi>
        <ProvideAuth>
          <App />
        </ProvideAuth>
      </ProvideApi>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
